import React, { useState, useEffect, useRef } from "react";
import { isRequired } from "../../pages/NewBrief/BriefUtils";
import { Globals } from "../../global/Globals";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

const BriefDateDropdown = ({
  name,
  placeholderText,
  onDateChange,
  selectedDate,
  inputLabel,
  minDate = null,
  maxDate = null,
  disabled = false,
  errorMessage ="",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onChange = (date) => {
    onDateChange(name, date);
    setIsOpen(false);
  };

  const onDateContainerClick = (event) => {
    setIsOpen((prev) => !prev);
  };
  return (
    <div className="date-container">
      {isRequired(inputLabel)}
      <div ref={dropdownRef}>
        <div
          onClick={!disabled ? onDateContainerClick : null}
          className={`brief-date-container ${
            selectedDate ? "brief-date-container-selected" : ""
          }`}
        >
          <label data-placeholder={selectedDate?.toString() || false}>
            {selectedDate
              ? format(new Date(selectedDate), "dd MMM yyyy")
              : (placeholderText || "Eg. 28 Feb 2025")}
          </label>
          <img class="dropdown-img" src="/images/calenderIcon.svg"></img>
        </div>
        {isOpen && (
          <div className="date-picker">
            <DatePicker
              selected={selectedDate}
              onChange={onChange}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              placeholderText="Select a month and year"
              inline
            />
          </div>
        )}
        
        {(!isOpen && !selectedDate && errorMessage) && <div><p className="invalidCredential1"><img src={Globals.IMG.ERROR} className='errorimg' alt="password error" /><span>{errorMessage}</span></p></div>}
      </div>
    </div>
  );
};

export default BriefDateDropdown;
